<template>
  <div class="clearfix">
    <a-upload
      v-model:file-list="fileList"
      list-type="picture-card"
      @preview="handlePreview"
      :customRequest="customRequest"
      @change="change"
      :multiple="number === 1 ? false : true"
      :accept="props.accept"
      :disabled="props.disabled"
      :showUploadList="{
        showPreviewIcon: true,
        showRemoveIcon: true,
        showDownloadIcon: true,
      }"
    >
      <div v-if="fileList.length < number && !props.disabled">
        <plus-outlined />
        <div style="margin-top: 8px">+上传</div>
      </div>
    </a-upload>
    <a-modal
      :open="previewVisible"
      :title="previewTitle"
      :footer="null"
      width="40%"
      @cancel="handleCancel"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits, watch } from 'vue'
  import imageCompression from 'browser-image-compression'
  import { baseURL } from '@/config'
  import axios from 'axios'
  import { getAccessToken } from '@/utils/auth'
  import { message } from 'ant-design-vue'
  const emit = defineEmits()
  const props = defineProps({
    modelValue: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    'allow-clear': {
      default: true,
    },
    number: {
      default: 1,
    },
    accept: {
      // default: '*/*', // image/*
      default: 'image/*', // image/*
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  })
  const fileList = ref(initFileList(props.modelValue))

  function initFileList(list) {
    if (!list?.length) return []
    if (list.indexOf(';') > -1) {
      list = list.split(';')
    } else if (!Array.isArray(list)) {
      list = list ? [list] : []
    }
    return list.map((item) => {
      if (item.constructor === String) return { status: 'done', url: item }
      if (item.constructor === Object)
        return { url: item.url, id: item.id, status: 'done' }
    })
  }

  function change(data) {
    const hasUploading = data.fileList.some(
      (item) => item.status === 'uploading'
    )
    if (hasUploading) return

    const doneList = data?.fileList?.length
      ? data.fileList.filter((item) => item.status === 'done')
      : []
    const formatList = doneList.map((item) => item.url || item?.response?.file)
    fileList.value = initFileList(
      props.number === 1 ? formatList[0] : formatList
    )
  }

  watch(fileList, function dataChange() {
    const hasUploading = fileList.value.some(
      (item) => item.status === 'uploading'
    )
    if (hasUploading) return
    emit('update:modelValue', getUrl(fileList.value))
  })

  function getUrl(fileList) {
    if (props.number === 1) {
      return (fileList[0]?.id ? fileList[0] : fileList[0]?.url) || ''
    }
    // return fileList.map((item) => (item.id ? item : item.url) || [])
    return fileList
  }

  function isCompressibleImage(file) {
    const imageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg']
    return file.type && imageTypes.includes(file.type)
  }

  // 封装Blob到File的转换方法
  function blobToFile(blob, originalFile) {
    return new File(
      [blob],
      originalFile.name,
      {
        type: originalFile.type || 'application/octet-stream',
        lastModified: originalFile.lastModified || Date.now()
      }
    )
  }

  async function customRequest({ file, onError, onSuccess }) {
    let uploadFile = file
    // 检测是否可压缩的图片
    if (isCompressibleImage(file)) {
      const _blob = await imageCompression(file, {
        maxSizeMB: 1,
        initialQuality: 1, // 初始压缩质量
        fileType: file.type
      })
      if (!(uploadFile instanceof Blob)) {
        throw new Error('压缩后文件格式无效')
      }
      uploadFile = blobToFile(_blob, file)
    }
    const formData = new FormData()
    formData.append('file[]', uploadFile)
    const { data } = await axios
      .post(baseURL + '/pre_upload/api/upload/files', formData, {
        headers: {
          Authorization: getAccessToken(),
          'Content-Type': 'multipart/form-data',
        },
      })
      .catch((err) => {
        message.warn('上传失败 ' + err.response?.data?.msg)
        onError({
          err: err,
        })
      })
    const { file_path } = data?.data[0]
    if (file_path) {
      onSuccess({ result: data?.data[0], file: file_path })
    } else {
      onError({
        err: data.message,
      })
    }
  }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }
  const previewVisible = ref(false)
  const previewImage = ref('')
  const previewTitle = ref('')

  const handleCancel = () => {
    previewVisible.value = false
    previewTitle.value = ''
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    previewImage.value = file.url || file.preview
    previewVisible.value = true
    previewTitle.value =
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
  }
</script>
<style scoped>
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
